import PropTypes from 'prop-types';
import LoginComponent from 'modules/shared/accountManagement/components/LoginComponent';

const LoginContainer = props => <LoginComponent {...props} />;

LoginContainer.propTypes = {
  stringsData: PropTypes.shape({}).isRequired,
};

export default LoginContainer;
